import { Button, Dialog, VSpacer } from "@/components/DesignSystem";
import { Stack, useTheme } from "@mui/material";
import { AboutAccountRolesModalContent } from "@/pages/CustomerDashboard/LinkedAccounts";
import { ApiUser } from "@api/interfaces";
import { AccountGroupRole } from "@shared/enums";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { useTranslation } from 'react-i18next';

interface AboutAccountRolesDialogProps {
  brandColor?: string,
  onClose: () => void,
  customerRole: AccountGroupRole,
  linkedAccounts: ApiUser[],
  pageType?: 'crd' | 'rp',
}
export const AboutAccountRolesDialog = ({
  brandColor,
  customerRole,
  linkedAccounts,
  onClose,
  pageType = 'crd',
}: AboutAccountRolesDialogProps) => {
  const { t } = useTranslation();
  const { isMobile } = useMediaQuery();
  const theme = useTheme();
  const shouldShowMobileVersion = pageType === 'crd' || isMobile;

  return (
    <Dialog
      cancelButton={() => {
        if (shouldShowMobileVersion) {
          return null;
        }
        return (
          <Button
            onClick={onClose}
            sx={{
              backgroundColor: brandColor ?? theme.palette.primary.main,
              '&:hover': {
                bgcolor: brandColor ?? theme.palette.primary.dark,
                opacity: 0.9,
              },
            }}
            testID="about-roles-modal-close-button"
          >
            {t($ => $.common.actions.close)}
          </Button>
        );
      }}
      fullScreen={isMobile}
      onClose={onClose}
      open
      showCloseButton={false}
      showTitle={false}
      sx={isMobile ? { borderRadius: '0px' } : {}}
      testID="about-account-roles-modal"
    >
      <Stack>
        <AboutAccountRolesModalContent
          customerRole={customerRole}
          linkedAccounts={linkedAccounts}
          pageType={pageType}
        />
        {shouldShowMobileVersion && (
          <>
            <VSpacer size="6" />
            <Button
              color="primary"
              fullWidth
              onClick={onClose}
              sx={{
                bgcolor: brandColor ?? theme.palette.primary.main,
                borderRadius: '100px',
                color: 'white',
                padding: '12px 24px',
                textTransform: 'none',
                '&:hover': {
                  bgcolor: brandColor ?? theme.palette.primary.dark,
                  opacity: 0.9,
                },
              }}
              testID="about-roles-modal-close-button"
              variant="contained"
            >
              {t($ => $.common.actions.close)}
            </Button>
          </>
        )}
        <VSpacer size="6" />
      </Stack>
    </Dialog>
  );
};
